import React, { useEffect, useState } from "react";
import styles from "../MegaMenu.css";
import { FADEIN_DELAY } from "./MegaMenuLinksSection";

export default function AnimatedTitle({ title, count, activeMenuIndex }) {
  const [className, setClassName] = useState(styles["LinksSection-Title"]);

  useEffect(() => {
    setClassName(styles["LinksSection-Title"]);
    setTimeout(() => {
      setClassName(
        [
          styles["LinksSection-Title"],
          styles["LinksSection-Title_visible"],
        ].join(" ")
      );
    }, count * FADEIN_DELAY);
  }, [activeMenuIndex]);

  return <div className={className}>{title}</div>;
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/MegaMenu/Components/AnimatedTitle.js